import { CircularCheckbox } from 'components/CircularCheckbox'
import { PlanTag } from 'components/planTag'
import { ThumbnailImgComponent } from 'pages/content-video-editor/components/shortvideo/ThumbnailImgComponent'
import { thumbnailOptions, ThumbnailOptionType } from 'dummy/data'
import { useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Controller } from 'react-hook-form'
import { ThumbnailType } from 'service/list'
import {
  getLocalStorage,
  initialThumbnailOption,
  LOCAL_THUMBNAIL_INFO,
  PREV_THUMBNAIL_INIT,
  removeLocalStorage,
} from 'utils/common'
import { MobileThumbnail } from './MobileThumbnail'
import { ThumbnailDiv } from './ThumbnailDiv'
import { Modal } from 'components/layout/Modal'
import classNames from 'classnames'

export const DirectMethodThumbnail = (props: any) => {
  const {
    translatePlanName,
    watch,
    thumbNailDivRef,
    thumbnailList,
    userInfo,
    setValue,
    control,
    error,
    setError,
    setOpenModal,
    setSelectedItem,
    isSaveThumbnail,
    setIsSaveThumbnail,
    isRememberChannel,
    setIsRememberChannel,
  } = props
  const channel = getLocalStorage('channel')
  const [selectedThumbnail, setSelectedThumbnail] = useState<ThumbnailType>()
  const [isMobileTModal, setMobileTModal] = useState<boolean>(false)
  const [thumbnailStatus, setThumbnailStatus] = useState<boolean[]>(
    new Array(thumbnailList?.length).fill(false)
  )
  const [isThumbnailModal, setThumbnailCheckModal] = useState<boolean>(false)
  const [prevThumbnail, setPrevThumbnail] = useState(PREV_THUMBNAIL_INIT)
  const [editThumbnail, setEditThumbnail] = useState<boolean>(false)

  const thumbnailRefs = useRef<(HTMLDivElement | null)[]>([])

  const handleThumbnail = (index: number) => {
    const updatedThumbnailState = thumbnailStatus.map((value, idx) =>
      idx === index ? true : false
    )
    setThumbnailStatus(updatedThumbnailState)
    setThumbnailCheckModal(false)
  }

  const handleThumbnailError = () => {
    const updateError = { ...error }
    updateError.thumbnail = false
    setError(updateError)
  }

  const [thumbnailType, setThumbnailType] = useState<ThumbnailOptionType>(
    initialThumbnailOption
  )

  useEffect(() => {
    if (!isSaveThumbnail) {
      setValue('thumbnailId', 0)
    }
  }, [])

  useEffect(() => {
    if (thumbnailList) {
      setThumbnailStatus(new Array(thumbnailList.length).fill(false))
    }
  }, [thumbnailList])

  useEffect(() => {
    if (channel) {
      setValue('thumbnailInfo.channelName', channel)
    }
  }, [channel])
  return (
    <>
      {' '}
      {isMobile ? (
        <>
          <div className="thumbnail_mobile flex flex-col items-center mb-[40px] px-4">
            <p className="font-bold text-[18px] mb-[16px] text-left w-full">
              썸네일 내용 입력 + 썸네일 스타일
            </p>
            <div className="flex justify-start w-full gap-5">
              {selectedThumbnail ? (
                <div className="flex gap-5">
                  <img
                    src={selectedThumbnail?.path}
                    alt="thumbnail"
                    className="w-[138px] h-[78px]"
                  />{' '}
                  <div className="flex h-full flex-col justify-between">
                    <span className="flex gap-[2px] ">
                      {selectedThumbnail?.name}
                      <PlanTag
                        planName={translatePlanName(
                          selectedThumbnail?.planName
                        )}
                      />
                    </span>
                    <button
                      className="px-2 py-[6px] bg-[#2E343D] text-[white] rounded-[4px] text-[14px] font-bold w-[53px]"
                      type="button"
                      onClick={() => {
                        setMobileTModal(true)
                      }}
                    >
                      선택 {'>'}
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="w-[138px] h-[78px] bg-[#EEF1F7]"></div>
                  <div className="flex flex-col gap-5">
                    <p className="text-error">썸네일을 선택해주세요!</p>
                    <button
                      className="px-2 py-[6px] bg-[#2E343D] text-[white] rounded-[4px] text-[14px] font-bold w-[53px]"
                      type="button"
                      onClick={() => {
                        setMobileTModal(true)
                      }}
                    >
                      선택 {'>'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className={classNames('thumbnail_pc', {
              'mb-4': watch('thumbnailId') !== 0,
              'mb-10': watch('thumbnailId') === 0,
            })}
            ref={thumbNailDivRef}
          >
            <div className="grid grid-cols-1 md:grid-cols-5  gap-y-[16px]">
              {thumbnailList?.map((thumbnail: ThumbnailType, index: number) => {
                return (
                  <>
                    <div
                      className={`flex gap-[24px] md:flex-col md:gap-2 relative ${thumbnail?.name} `}
                      key={index}
                      ref={(el) => (thumbnailRefs.current[index] = el)}
                    >
                      <ThumbnailImgComponent
                        thumbnail={thumbnail}
                        index={thumbnailStatus[index]}
                      />
                      <div
                        className={`relative flex gap-[8px] items-center ${thumbnail?.name}`}
                      >
                        <Controller
                          render={({ field }) => (
                            <CircularCheckbox
                              {...field}
                              id={index}
                              checked={watch('thumbnailId') === thumbnail.id}
                              disabled={!userInfo || !thumbnail?.usable}
                              onChange={() => {
                                setValue('thumbnailId', thumbnail.id)
                                setSelectedItem(thumbnail)
                                handleThumbnail(index)
                                setValue('thumbnailInfo', {
                                  channelName: channel ?? '',
                                  title1: '',
                                  title2: '',
                                  title3: '',
                                  thumbnailFile: [],
                                })
                                setThumbnailType(
                                  thumbnailOptions[
                                    `thumbnail_${thumbnail.name}`
                                  ]
                                )
                              }}
                              label={thumbnail.name}
                            />
                          )}
                          name="thumbnailId"
                          control={control}
                        />

                        <PlanTag
                          planName={translatePlanName(thumbnail.planName)}
                          className="absolute left-[35%] top-0"
                        />
                      </div>
                    </div>
                  </>
                )
              })}
            </div>
          </div>

          <ThumbnailDiv
            key={watch('thumbnailId')} // key 값 설정
            thumbnailId={watch('thumbnailId')}
            editThumbnail={editThumbnail}
            userInfo={userInfo}
            thumbnailType={thumbnailType}
            setValue={setValue}
            watch={watch}
            control={control}
            error={error.thumbnail}
            handleThumbnailError={handleThumbnailError}
            isRememberChannel={isRememberChannel}
            setIsRememberChannel={setIsRememberChannel}
          />
        </>
      )}
      {isMobileTModal && (
        <MobileThumbnail
          translatePlanName={translatePlanName}
          thumbnailList={thumbnailList ?? []}
          isMobileTModal={isMobileTModal}
          setMobileTModal={setMobileTModal}
          userInfo={userInfo}
          thumbnailType={thumbnailType}
          setThumbnailType={setThumbnailType}
          setValue={setValue}
          watch={watch}
          control={control}
          selectedThumbnail={selectedThumbnail}
          setSelectedThumbnail={setSelectedThumbnail}
          setOpenModal={setOpenModal}
          setSelectedItem={setSelectedItem}
        />
      )}
      {isThumbnailModal && (
        <Modal isModal={isThumbnailModal}>
          <div className="bg-white w-[400px] h-[184px] p-[20px] border-t rounded-t-[20px]">
            <div className="flex flex-col items-center justify-center h-full gap-[24px]">
              <p className="font-bold text-[18px]">
                ✅ 썸네일 스타일을 변경하시겠어요?
              </p>
              <div className="flex flex-col leading-[22px]">
                <p className=" text-[14px] ">
                  썸네일 스타일을 변경하시면
                  <br />
                  이미 선택하신 스타일의 썸네일에 입력된 내용은 삭제됩니다.
                </p>
              </div>
            </div>
          </div>
          <div className="w-[400px] text-[14px]  h-[60px]  flex justify-center items-center">
            <button
              className=" w-[50%] h-full text-black bg-[#EEF1F7] rounded-bl-[20px] border-b border-[#EEF1F7] "
              onClick={() => {
                setThumbnailCheckModal(false)
              }}
              type="button"
            >
              취소
            </button>
            <button
              className="text-white w-[50%] h-full bg-main rounded-br-[20px] border-b border-main"
              onClick={() => {
                setValue('thumbnailId', prevThumbnail.id)
                removeLocalStorage(LOCAL_THUMBNAIL_INFO)
                setValue('thumbnailInfo', {
                  channelName: '',
                  title1: '',
                  title2: '',
                  title3: '',
                  thumbnailFile: [],
                })
                handleThumbnail(prevThumbnail.index)
              }}
              type="button"
            >
              변경
            </button>
          </div>
        </Modal>
      )}
    </>
  )
}
